import { IAppState } from 'shared/common/state';

export const selectIsUserAgent = (state: IAppState) => {
  const { user } = state;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return !user.isAuthenticated ? false : user.isAgent && !(user as any).isBuilder;
};
